import React, { useState, useContext, useEffect } from "react";
import getProfileLabel from "../genericFunctions/getProfileLabel";
import { useHistory } from "react-router-dom";
import ExperienceItem from "./ExperienceItem";
import Grid from "@material-ui/core/Grid";
import { AuthContext } from "../context/AuthContext";
import { ScreenSizeContext } from "../context/ScreenSizeContext";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import sortDatesIncludingPresent from "../genericFunctions/sortDatesIncludingPresent";

const Experiences = (props) => {
  const onSubmitExperiences = props.onSubmitExperiences;
  const handleRemoveExperience = props.handleRemoveExperience;
  const updateExperience = props.updateExperience;
  const experiences = props.experiences;
  const [experience, setExperience] = useState({
    name: "",
    description: "",
    tools: "",
    fromDate: null,
    toDate: null,
    currentJob: false,
    role: "",
  });

  const [addingNew, setAddingNew] = useState(false);
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const { onMobile } = useContext(ScreenSizeContext);

  useEffect(() => {
    if (!authContext.isAuthenticated) {
      history.push("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (experience.currentJob) {
      setExperience({ ...experience, toDate: "" });
    } else if (!experience.currentJob) {
      setExperience({ ...experience });
    }
  }, [experience.currentJob]); // eslint-disable-line react-hooks/exhaustive-deps

  const onChange = (e) => {
    const target = e.target;

    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setExperience({ ...experience, [name]: value });
  };
  const validateExperience = () => {
    if (
      experience.name === "" ||
      experience.description === "" ||
      experience.tools === "" ||
      experience.fromDate === null ||
      ((experience.toDate === null ||
        isNaN(Date.parse(experience.toDate)) ||
        experience.fromDate.getTime() > experience.toDate.getTime()) &&
        experience.currentJob === false) ||
      experience.role === "" ||
      isNaN(Date.parse(experience.fromDate))
    ) {
      return false;
    }

    return true;
  };

  return (
    <Paper
      elevation={3}
      style={{
        margin: !onMobile ? "10px 10px 10px 0px" : "10px 0px",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minWidth: !props.onMobile ? "45%" : "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
            borderBottom: "1px solid #e1e1e1",
          }}
        >
          <h4>{getProfileLabel(props.profileLanguage, "experiences")}</h4>
          <IconButton
            onClick={() => setAddingNew(true)}
            variant="outlined"
            color="primary"
          >
            <AddIcon />
          </IconButton>
        </div>
        {addingNew && (
          <Paper
            elevation={1}
            style={{
              margin: "10px 0px",
              padding: "10px",

              display: "flex",
              flexDirection: "column",
              minWidth: "45%",
            }}
          >
            <form
              onSubmit={(e) => {
                setAddingNew(false);
                onSubmitExperiences(e, experience);
                setExperience({
                  _id: undefined,
                  name: "",
                  description: "",
                  tools: "",
                  fromDate: null,
                  toDate: null,
                  currentJob: false,
                  role: "",
                });
              }}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <TextField
                type="text"
                name="name"
                label="Company"
                value={experience.name}
                onChange={onChange}
                style={{ margin: "5px 0px" }}
                variant="outlined"
              />
              <TextField
                type="text"
                name="role"
                label="Role"
                value={experience.role}
                onChange={onChange}
                style={{ margin: "5px 0px" }}
                variant="outlined"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={experience.currentJob}
                    onChange={onChange}
                    name="currentJob"
                    value={experience.currentJob}
                    color="primary"
                  />
                }
                label="Current job"
                style={{ width: "30.5%", padding: "10px 2px 5px" }}
              />
              <div style={{ display: "flex" }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container justify="space-between">
                    <KeyboardDatePicker
                      inputVariant="outlined"
                      disableToolbar
                      variant="inline"
                      format="MM/yyyy"
                      views={["year", "month"]}
                      margin="normal"
                      id="date-picker-inline"
                      InputLabelProps={{ shrink: true }}
                      label="From date"
                      value={experience.fromDate}
                      onChange={(date) => {
                        setExperience({ ...experience, fromDate: date });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      style={{ width: "40%" }}
                    />
                    {!experience.currentJob && (
                      <KeyboardDatePicker
                        inputVariant="outlined"
                        disableToolbar
                        variant="inline"
                        format="MM/yyyy"
                        views={["year", "month"]}
                        margin="normal"
                        id="date-picker-inline"
                        InputLabelProps={{ shrink: true }}
                        label="To date"
                        value={experience.toDate}
                        onChange={(date) => {
                          setExperience({ ...experience, toDate: date });
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        style={{ width: "40%" }}
                      />
                    )}
                  </Grid>
                </MuiPickersUtilsProvider>
              </div>
              <TextField
                type="text"
                name="tools"
                label="Tools"
                value={experience.tools}
                onChange={onChange}
                style={{ margin: "5px 0px" }}
                variant="outlined"
              />
              <TextField
                type="text"
                name="description"
                label="Description"
                value={experience.description}
                onChange={onChange}
                multiline
                rows={4}
                variant="outlined"
                style={{ margin: "5px 0px" }}
              />
              <div style={{ display: "flex", marginTop: "10px" }}>
                <Button
                  disabled={!validateExperience()}
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={{ marginRight: "10px" }}
                >
                  Add Experience
                </Button>
                <Button
                  type="button"
                  variant="outlined"
                  color="secondary"
                  onClick={() => setAddingNew(false)}
                >
                  Cancel
                </Button>
              </div>
            </form>
          </Paper>
        )}
        {experiences === undefined || experiences.length <= 0 ? (
          <p style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            {getProfileLabel(props.profileLanguage, "noExperiences")}
          </p>
        ) : (
          experiences
            .sort((a, b) => sortDatesIncludingPresent(a.toDate, b.toDate))
            .map((experience) => {
              return (
                <ExperienceItem
                  key={experience._id}
                  experience={experience}
                  profileLanguage={props.profileLanguage}
                  removeExperience={(experience) =>
                    handleRemoveExperience(experience)
                  }
                  updateExperience={(e, experience) =>
                    updateExperience(e, experience)
                  }
                />
              );
            })
        )}
      </div>
    </Paper>
  );
};

export default Experiences;
